<div class="list-panel">
  <div class="list-container">
    <div class="list-header">
      <div class="header-left">
        <app-back-button
          [title]="'Boundaries List' | translate"
          [parentRoute]="'/fields-identification'"></app-back-button>
      </div>
    </div>

    <div class="content-wrapper-row">
      <div class="table-section">
        <div class="table-wrapper">
          <div
            class="loading-indicator"
            *ngIf="isLoading">
            <p>{{ "Loading..." | translate }}</p>
          </div>

          <p-table
            [value]="boundaries"
            [scrollable]="true"
            scrollHeight="flex"
            styleClass="p-datatable-gridlines custom-table"
            [tableStyle]="{ 'min-width': '60rem' }">
            <ng-template pTemplate="header">
              <tr>
                <th>{{ "External ID" | translate }}</th>
                <th>{{ "Region / District" | translate }}</th>
                <th>{{ "Poly ID" | translate }}</th>
                <th>{{ "Area (ha)" | translate }}</th>
                <th>{{ "Perimeter (m)" | translate }}</th>
                <th>{{ "Created At" | translate }}</th>
                <th style="width: 60px"></th>
              </tr>
            </ng-template>
            <ng-template
              pTemplate="body"
              let-item>
              <tr>
                <td>{{ item.cadastralNumber || "-" }}</td>
                <td>
                  <div class="location-cell">
                    <span class="region-name">
                      {{ (getRegionDisplayInfo(item.regionId).region | serverTranslate: "names") || "-" }}
                    </span>
                    <span class="district-name">
                      {{ (getRegionDisplayInfo(item.regionId).district | serverTranslate: "names") || "-" }}
                    </span>
                  </div>
                </td>
                <td>{{ item.polyId || "-" }}</td>
                <td>{{ item.areaHa | number: "1.2-2" }}</td>
                <td>{{ item.perimeterM | number: "1.2-2" }}</td>
                <td>{{ item.createAt | date: "dd.MM.yyyy HH:mm" }}</td>
                <td class="text-center">
                  <button
                    pButton
                    type="button"
                    icon="pi pi-pencil"
                    class="p-button-rounded p-button-text p-button-secondary"
                    (click)="openEditModal(item)"></button>
                </td>
              </tr>
            </ng-template>
            <ng-template pTemplate="emptymessage">
              <tr>
                <td
                  colspan="7"
                  class="text-center p-4">
                  {{ "No data found" | translate }}
                </td>
              </tr>
            </ng-template>
          </p-table>
        </div>

        <div
          class="mt-2"
          *ngIf="totalCount > 0">
          <app-custom-paginator
            [first]="first"
            [pageSize]="pageSize"
            [totalRecords]="totalCount"
            (pageChange)="onPageChange($event)"
            (pageSizeChange)="onPageSizeChange($event)"></app-custom-paginator>
        </div>
      </div>

      <div class="filters-sidebar">
        <div class="filter-header">
          <h3>{{ "Filters" | translate }}</h3>
        </div>

        <div class="filter-group">
          <label>{{ "Region" | translate }}</label>
          <p-treeSelect
            [(ngModel)]="selectedRegion"
            [options]="regionNodes"
            placeholder="{{ 'Select Region' | translate }}"
            [filter]="true"
            [showClear]="true"
            appendTo="body"
            containerStyleClass="w-full"></p-treeSelect>
        </div>

        <div class="filter-group">
          <label>{{ "Date Range" | translate }}</label>
          <p-datepicker
            [(ngModel)]="dateRange"
            selectionMode="range"
            [readonlyInput]="true"
            inputId="range"
            [showIcon]="true"
            dateFormat="dd.mm.yy"
            placeholder="{{ 'Select Date Range' | translate }}"
            [style]="{ width: '100%' }"
            [inputStyle]="{ width: '100%' }"></p-datepicker>
        </div>

        <div class="filter-actions mt-4">
          <button
            pButton
            type="button"
            label="{{ 'Apply' | translate }}"
            class="p-button-primary w-full"
            (click)="applyFilters()"></button>

          <button
            pButton
            type="button"
            label="{{ 'Reset' | translate }}"
            class="p-button-outlined p-button-secondary w-full mt-2"
            (click)="resetFilters()"></button>
        </div>
      </div>
    </div>
  </div>
</div>

<app-field-boundary-modal
  [(visible)]="displayModal"
  [fieldData]="selectedField"
  (actionCompleted)="onActionCompleted()"></app-field-boundary-modal>
